import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Colabora } from '../models/colabora';
import { Registrouni } from 'src/models/registrouni';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ColaboraFormService {

  constructor(private http: HttpClient) { }
  /**/
  private  apiURL =   environment.URL_API_MAGNO + '/api';
  //private  apiURL_2 = environment.URL_API_LEGALES + '/api';

  private  apiURLAniv = environment.URL_API_ANIV + '/api';
  
  //private  apiURL = 'http://localhost:2393/api';
  //private  apiURL_2 = 'http://localhost:3000/api';

  getEgresadosLink(matricula: any) {
    return this.http.get(`${this.apiURL}/pasalavoz/GetEgresado/` + matricula);
  }

  sendFormColabora(formulario: Colabora, tokenS: string){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + tokenS
    });
    return this.http.post(`${this.apiURL}/Colaborador/RegistroColaboradorGeneral`, formulario, { headers } );
  }



  sendFormColaboraAniv(formulario: Colabora, tokenS: string){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + tokenS
    });
    return this.http.post(`${this.apiURLAniv}/Colaborador/RegistroColaboradorGeneral`, formulario, { headers } );
  }

  
}
